module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.busy) ? _c('h2', [_vm._v("loading...")]) : _vm._e(), _vm._v(" "), _c('UserCreator', {
    attrs: {
      "step": "1",
      "active": _vm.activeStep === 'UserCreator'
    },
    on: {
      "success": _vm.setActive,
      "editView": _vm.editView,
      "editDone": _vm.editDone,
      "login": _vm.routeLogin
    }
  }), _vm._v(" "), _c('Review', {
    attrs: {
      "step": "2",
      "active": _vm.activeStep === 'Review'
    },
    on: {
      "success": _vm.setActive,
      "editView": _vm.editView,
      "editDone": _vm.editDone
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e5a339e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepsQuick.vue
// module id = 367
// module chunks = 1